export default __webpack_public_path__ + "static/media/image_companies.05e079c7.jpg";